module.exports = __webpack_public_path__ + "img/history-reconcile.b9fae052.svg";